import { Tabs } from 'antd';
import { useSearchParams } from 'react-router-dom';
import PageTitle from 'components/page-title';
import MissionsTab from './components/missions-tab';
import ReviewsTab from './components/reviews-tab';

const TAB_KEYS = ['list', 'reviews'];

const StarMissionsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 'list';
  const activeKey = TAB_KEYS.includes(tab) ? tab : 'list';

  return (
    <div>
      <PageTitle title="Nhiệm vụ Sao" />
      <Tabs
        activeKey={activeKey}
        onChange={(key) => setSearchParams(key === 'list' ? {} : { tab: key })}
        destroyOnHidden
        items={[
          { key: 'list', label: 'Nhiệm vụ', children: <MissionsTab /> },
          { key: 'reviews', label: 'Hàng chờ duyệt', children: <ReviewsTab /> },
        ]}
      />
    </div>
  );
};

export default StarMissionsPage;
